/**
 *
 * Records Page
 *
 */
import React, { useState, useEffect, useRef } from "react"
import Select from "react-select"
import Modal from "react-bootstrap/Modal"
import MetaTags from "react-meta-tags"
import { withRouter } from "react-router-dom"
import moment from "moment"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Label,
  Table,
  Spinner,
  Input,

  // CardTitle
} from "reactstrap"
import api from "helpers/Api"
import { connect } from "react-redux"
import PropTypes from "prop-types"
//Import Breadcrumb
import { useSelector, useDispatch } from "react-redux"
import { isEmpty } from "lodash"
import Breadcrumbs from "../../components/Common/Breadcrumb"
//Import Styles
import "./styles.scss"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import { ReactSearchAutocomplete } from "react-search-autocomplete"
import { ToastContainer } from "react-toastify"
import SimpleReactValidator from "simple-react-validator"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
import * as employeeRecordAction from "../../store/ZW1wbG95ZWUtcmVjb3Jk/actions"
import * as employeeAction from "../../store/RW1wbG95ZWVSZXF1ZXN0/actions"
import ButtonSpinner from "../../components/ButtonSpinner"

const EmployeeRecord = (props) => {
  const title = "Employee Leave Record"
  const { dispatch, searchBtnStyle } = props
  //component and validations
  const specificDispatch = useDispatch()
  const simpleValidator = useRef(new SimpleReactValidator())
  const [, forceUpdate] = useState()

  const mode = "hrms"

  // let id = useParams()
  useEffect(() => {
    dispatch(employeeRecordAction.loadRecordsMetaData())
    dispatch(employeeRecordAction.loadEmployee())
    dispatch(employeeAction.loadProcessStatus(mode))
    dispatch(
      employeeRecordAction.loadEmployeeRecord({ employeeInactive: false, page: 1, limit: 50, })
    )
    setApplyFilter(false)
  }, [])
  //
  const [searchFilter, setSearchFilter] = useState(false)
  const [searchInput, setSearchInput] = useState("")
  const leaveUpdate = useSelector(
    (specificstate) => specificstate.employeeRecord
  )
  const {
    recordsMetaData = {},
    employee_list = [],
    employee_record = [],
  } = leaveUpdate

  const [pageCount, setPageCount] = useState(false)
  const [pageChange, setPageChange] = useState(false)
  const [loading, setLoading] = useState(false)
  const [employeeRecordData, setEmployeeRecordData] = useState({
    company: [],
    branch: [],
    department: [],
    employeeCode: "",
    fromDate: "",
    toDate: "",
    count: "",
    lossOfPay: [],
  })
  const handleChange = (e) => {
    // console.log(e)
    setEmployeeRecordData({
      ...employeeRecordData,
      [e.target.name]: e.target.value,
    })
  }
  const [downloadLoading, setDownloadLoading] = useState(false)
  //dropdown list
  const [companies, setCompanies] = useState([])
  const [branches, setBranches] = useState([])
  const [departmentlist, setDepartmentlist] = useState([])
  const [designation, setDesignation] = useState([])
  const [employeeCode, setEmployeeCode] = useState([])
  const [btnLoader, setBtnLoader] = useState(false)
  const [applyFilter, setApplyFilter] = useState(false)
  const [employeeActive, setEmployeeActive] = useState("")

  //Leave edit
  /// Count list start

  const [leaveCL, setLeaveCL] = useState(false)
  const [leaveCLDetails, setLeaveCLDetails] = useState("")
  const handleLeaveCL = () => setLeaveCL(false)

  const [permissionCount, setPermissionCount] = useState(false)
  const [permissionDetails, setPermissionDetails] = useState("")
  const handlePermissionCount = () => setPermissionCount(false)

  const [leaveAbsent, setLeaveAbsent] = useState(false)
  const [leaveAbsentDetails, setLeaveAbsentDetails] = useState("")
  const handleLeaveAbsent = () => setLeaveAbsent(false)

  const [delegationCount, setDelegationCount] = useState(false)
  const [delegationDetails, setDelegationDetails] = useState("")
  const handleDelegationAbsent = () => setDelegationCount(false)

  const [nightShift, setNightShift] = useState(false)
  const [nightShiftDetails, setNightShiftDetails] = useState("")
  // const [shiftAttachment, setShiftAttachment] = useState("")
  const handleNightShift = () => setNightShift(false)

  const [leaveSL, setLeaveSL] = useState(false)
  const [leaveSLDetails, setLeaveSLDetails] = useState("")
  const handleLeaveSL = () => setLeaveSL(false)

  const [leaveGL, setLeaveGL] = useState(false)
  const [leaveGLDetails, setLeaveGLDetails] = useState("")
  const handleLeaveGL = () => setLeaveGL(false)

  //Update LPND status
  const branchOptions =
    !isEmpty(recordsMetaData) &&
    recordsMetaData.branchOptions.filter(
      (branch) =>
        branch.companyId ===
        companies.map((company) => company.value).toString()
    )

  const handleCompaniesChange = (e) => {
    setCompanies(e)
    setBranches([])
    setDepartmentlist([])
    setDesignation([])
  }
  const employeeList =
    !isEmpty(employee_list) &&
    employee_list.map((employee) => {
      return {
        _id: employee._id,
        empCode: employee.empCode,
        name: employee.name,
        companyId: employee.companyId,
        companyName: employee.companyName,
        branchName: employee.branchName,
        branchId: employee.branchId,
        departmentName: employee.departmentName,
        departmentId: employee.departmentId,
        designationName: employee.designationName,
        designationId: employee.designationId,
        roleId: employee.roleId,
      }
    })

  const createOptions = (array) => {
    const options = []
    !isEmpty(array) &&
      array.forEach((element) => {
        const labelEmployee = element.empCode.concat(" - ", element.name)
        // [...element.empCode,...element.name].join('')

        let obj = {}
        obj.value = element._id
        obj.label = labelEmployee
        obj.empCode = element.empCode
        obj.name = element.name
        obj.companyId = element.companyId
        obj.companyName = element.companyName
        obj.branchId = element.branchId
        obj.branchName = element.branchName
        obj.departmentId = element.departmentId
        obj.departmentName = element.departmentName
        obj.designationId = element.designationId
        obj.designationName = element.designationName
        obj.roleId = element.roleId
        options.push(obj)
      })
    return options
  }

  const employeeOptions = createOptions(employeeList)

  const fuseOptions = {
    keys: ["empCode", "label"],
  }
  const company =
    !isEmpty(companies) && companies.map((company) => company.value)
  const branch = !isEmpty(branches) && branches.map((branch) => branch.value)
  //submit values
  const [countFilterData, setCountFilterData] = useState(false)

  //Count filter

  const d1 = new Date(employeeRecordData.fromDate)
  const d2 = new Date(employeeRecordData.toDate)

  var diff = d2.getTime() - d1.getTime()

  // console.log(diff, "diff Date")
  const counterDate = diff / (1000 * 60 * 60 * 24) + 1

  const countFilter = (e) => {
    e.preventDefault()
    if (simpleValidator.current.allValid()) {
      var searchCount = employeeRecordData.count
      var searchFromDate =
        employeeRecordData && employeeRecordData.fromDate
          ? employeeRecordData.fromDate
          : ""
      var searchToDate =
        employeeRecordData && employeeRecordData.toDate
          ? employeeRecordData.toDate
          : ""
      var searchEmpId =
        employeeCode && employeeCode.value ? employeeCode.value : ""
      var searchEmpCode =
        employeeCode && employeeCode.empCode ? employeeCode.empCode : ""
      var searchFilterType = "count"
      var searchEmpActive =
        employeeActive && employeeActive === true ? true : false
      // console.log(employeeCode, "employee list")
      var searchvalue = {}
      searchvalue.filterType = searchFilterType
      searchvalue.page = pageChange ? pageCount : 1
      searchvalue.limit = sizePerPage ? sizePerPage : 50
      if (searchCount) {
        searchvalue.count = searchCount
      }
      if (searchFromDate) {
        searchvalue.startDate = searchFromDate
      }
      if (searchToDate) {
        searchvalue.endDate = searchToDate
      }
      if (searchEmpId) {
        searchvalue.empId = searchEmpId
      }
      if (searchEmpCode) {
        searchvalue.empCode = searchEmpCode
      }
      if (searchEmpActive) {
        searchvalue.employeeInactive = searchEmpActive
      }
      specificDispatch(employeeRecordAction.loadEmployeeRecord(searchvalue))

      setApplyFilter(true)
      setCountFilterData(true)
      setBtnLoader(true)
      setTimeout(() => {
        setBtnLoader(false)
      }, 2000)
    } else {
      simpleValidator.current.showMessages()
      forceUpdate(1)
    }
  }
  // console.log(employeeCode, "employee list")

  //Aplly filter section
  const handleApply = () => {
    var searchCompany = company && company ? company : ""
    var searchBranch = branch && branch ? branch : ""
    var searchDepartment =
      departmentlist && departmentlist.value ? [departmentlist.value] : ""
    var searchDesignation =
      designation && designation.value ? [designation.value] : ""
    // var searchLeaveType =
    //   leaveTypeList && leaveTypeList.label ? [leaveTypeList.label] : ""
    var searchEmpCode =
      employeeCode && employeeCode.value ? employeeCode.value : ""

    var searchFromDate =
      employeeRecordData && employeeRecordData.fromDate
        ? employeeRecordData.fromDate
        : ""
    var searchToDate =
      employeeRecordData && employeeRecordData.toDate
        ? employeeRecordData.toDate
        : ""


    var searchEmpActive =
      employeeActive && employeeActive == true ? true : false
    var searchvalue = {}
    searchvalue.page = pageChange ? pageCount : 1
    searchvalue.limit = sizePerPage ? sizePerPage : 50

    if (searchCompany) {
      searchvalue.company = searchCompany
    }
    if (searchBranch) {
      searchvalue.branch = searchBranch
    }
    if (searchDepartment) {
      searchvalue.department = searchDepartment
    }
    if (searchDesignation) {
      searchvalue.designation = searchDesignation
    }
    if (searchEmpCode) {
      searchvalue.empId = searchEmpCode
    }
    if (searchFromDate) {
      searchvalue.startDate = searchFromDate
    }
    if (searchEmpActive) {
      searchvalue.employeeInactive = searchEmpActive
    }
    if (searchToDate) {
      searchvalue.endDate = searchToDate
    }

    // if (searchStatus) {
    //   searchvalue.leaveStatus = searchStatus
    // }

    specificDispatch(employeeRecordAction.loadEmployeeRecord(searchvalue))
    setBtnLoader(true)
    setApplyFilter(true)
    setTimeout(() => {
      setBtnLoader(false)
    }, 2000)
  }

  // console.log(leaveStatus, "Leave Status")
  //Data table
  let slNo = 0
  const employeeRecordTable = !isEmpty(employee_record)
    ? employee_record.data.map((employeeRecord, index) => {
      slNo = slNo + 1

      var str = !isEmpty(employeeRecord.attachment)
        ? employeeRecord.attachment
        : []

      // console.log(str, "string attachments")
      const fileUrl = isEmpty(str) ? "" : str.substring(str.indexOf("/"))
      // console.log(fileUrl, "string attachments")
      const attachments = isEmpty(fileUrl)
        ? ""
        : "https://api.alphaone.app/uploads/" + fileUrl
      console.log(attachments, "attachment with alpha url")
      var fromDateTime = !isEmpty(employeeRecord.fromDate)
        ? moment(employeeRecord.fromDate)
          .subtract(5, "hours")
          .subtract(30, "minutes")
          .format("DD-MM-YYYY")
        : []

      var toDateTime = !isEmpty(employeeRecord.toDate)
        ? moment(employeeRecord.toDate)
          .subtract(5, "hours")
          .subtract(30, "minutes")
          .format("DD-MM-YYYY")
        : []

      return {
        _id: employeeRecord._id,
        sNo: slNo,
        branchId: employeeRecord.branchId,
        branchName: employeeRecord.branchName,
        companyId: employeeRecord.companyId,
        companyName: employeeRecord.companyName,
        departmentId: employeeRecord.departmentId,
        departmentName: employeeRecord.departmentName,
        designationId: employeeRecord.designationId,
        designationName: employeeRecord.designationName,
        employeeCode: employeeRecord.employeeCode,
        employeeName: employeeRecord.employeeName,
        workingDays: employeeRecord.workingDays,
        fromDate: fromDateTime,
        status: (
          <button
            onClick={() => {
              // setRequestStatus(employeeRecord.status)
            }}
            className={
              (employeeRecord.status === "Approved" &&
                "approved-btn disabled-button") ||
              (employeeRecord.status === "Pending" && "pending-btn") ||
              (employeeRecord.status === "Onhold" && "hold-btn") ||
              (employeeRecord.status === "Recheck" && "recheck-btn") ||
              (employeeRecord.status === "Rejected" && "reject-btn") ||
              (employeeRecord.status === "Accepted" && "accept-btn")
            }
          >
            {employeeRecord.status}
          </button>
        ),
        leaveCl: employeeRecord.cl,
        clHour: employeeRecord.clHour,
        clDetail: employeeRecord.clDetail,
        leaveCL:
          employeeRecord.cl + `${"("} ${employeeRecord.clHour} ${"hrs)"}`,
        leaveSl: employeeRecord.sl,
        slHour: employeeRecord.slHour,
        slDetail: employeeRecord.slDetail,
        leaveSL:
          employeeRecord.sl + `${"("} ${employeeRecord.slHour} ${"hrs)"}`,
        leaveGl: employeeRecord.gl,
        glHour: employeeRecord.glHour,
        glDetail: employeeRecord.glDetail,
        leaveGL:
          employeeRecord.gl + `${"("} ${employeeRecord.glHour} ${"hrs)"}`,
        permission: employeeRecord.permission,
        permissionHour: employeeRecord.permissionHour,
        permissionDetail: employeeRecord.permissionDetail,
        permissionCount:
          employeeRecord.permission +
          `${"("} ${employeeRecord.permissionHour} ${"hrs)"}`,
        absent: employeeRecord.absent,
        absentHour: employeeRecord.absentHour,
        absentDetail: employeeRecord.absentDetail,
        leaveAbsent:
          employeeRecord.absent +
          `${"("} ${employeeRecord.absentHour} ${"hrs)"}`,

        leaveLate: (
          <span
            style={{ color: "#E40D8C", cursor: "pointer", fontSize: "14px" }}

          >
            {employeeRecord.late}
          </span>
        ),
        delegation: employeeRecord.delegation,
        delegationHour: employeeRecord.delegationHour,
        delegationDetail: employeeRecord.delegationDetail,
        delegationLeave:
          employeeRecord.delegation +
          `${"("} ${employeeRecord.delegationHour} ${"hrs)"}`,
        nightShift: employeeRecord.nightShift,
        nightShiftHour: employeeRecord.nightShiftHour,
        nightShiftDetail: employeeRecord.nightShiftDetail,
        nightShiftLeave:
          employeeRecord.nightShift +
          `${"("} ${employeeRecord.nightShiftHour} ${"hrs)"}`,

        balanceCL: employeeRecord.balanceCl,
        balanceSL: employeeRecord.balanceSl,
        balancePermission: employeeRecord.balancePermission,
        duration: employeeRecord.duration,
        toDate: toDateTime,
        approvedBy: (
          <Button
            type="submit"
            onClick={() => { }}
            style={{ fontSize: "10px" }}
            className="btn btn-info buttons"
          >
            <i className="fas fa-eye icon-btn"></i>
          </Button>
        ),
        key: index,
      }
    })
    : []

  //pagination table
  const columns = [
    {
      dataField: "sNo",
      text: "S.No",
    },

    {
      dataField: "employeeCode",
      text: "Employee Code",
      sort: true,
      style: { color: "#E40D8C" },
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "employeeName",
      text: "Employee Name",
      sort: true,
      headerStyle: {
        minWidth: "170px",
      },
    },
    {
      dataField: "companyName",
      text: "Company",
      sort: true,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "branchName",
      text: "Branch",
      sort: true,
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "departmentName",
      text: "Department",
      sort: true,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "designationName",
      text: "Designation",
      sort: true,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "leaveCL",
      text: "CL",
      sort: true,
      formatter: (cellContent, row) => {
        return (
          <span
            style={{ color: "#E40D8C", cursor: "pointer", fontSize: "14px" }}
            onClick={() => {
              setLeaveCL(true)
              setLeaveCLDetails(row.clDetail)
            }}
          >
            {row.leaveCl}
            <span
              style={{
                color: "#000000",
                marginLeft: "2px",
                fontSize: "12px",
              }}
            >
              ({row.clHour + "hrs"})
            </span>
          </span>
        )
      },
      headerStyle: {
        minWidth: "170px",
      },
    },
    {
      dataField: "leaveSL",
      text: "SL",
      sort: true,
      formatter: (cellContent, row) => {
        return (
          <span
            style={{ color: "#E40D8C", cursor: "pointer", fontSize: "14px" }}
            onClick={() => {
              setLeaveSLDetails(row.slDetail)

              setLeaveSL(true)
            }}
          >
            {row.leaveSl}
            <span
              style={{
                color: "#000000",
                marginLeft: "2px",
                fontSize: "12px",
              }}
            >
              ({row.slHour + "hrs"})
            </span>
          </span>
        )
      },
      headerStyle: {
        minWidth: "170px",
      },
    },
    {
      dataField: "leaveGL",
      text: "GL",
      sort: true,
      formatter: (cellContent, row) => {
        return (
          <span
            style={{ color: "#E40D8C", cursor: "pointer", fontSize: "14px" }}
            onClick={() => {
              setLeaveGLDetails(row.glDetail)
              setLeaveGL(true)
            }}
          >
            {row.leaveGl}
            <span
              style={{
                color: "#000000",
                marginLeft: "2px",
                fontSize: "12px",
              }}
            >
              ({row.glHour + "hrs"})
            </span>
          </span>
        )
      },
      headerStyle: {
        minWidth: "170px",
      },
    },
    {
      dataField: "permissionCount",
      text: "Permission Count",
      sort: true,
      formatter: (cellContent, row) => {
        return (
          <span
            style={{ color: "#E40D8C", cursor: "pointer", fontSize: "14px" }}
            onClick={() => {
              setPermissionDetails(row.permissionDetail)

              setPermissionCount(true)
            }}
          >
            {row.permission}
            <span
              style={{
                color: "#000000",
                marginLeft: "2px",
                fontSize: "12px",
              }}
            >
              ({row.permissionHour + "hrs"})
            </span>
          </span>
        )
      },
      headerStyle: {
        minWidth: "180px",
      },
    },
    {
      dataField: "leaveAbsent",
      text: "Employee Default",
      sort: true,
      formatter: (cellContent, row) => {
        return (
          <span
            style={{ color: "#E40D8C", cursor: "pointer", fontSize: "14px" }}
            onClick={() => {
              setLeaveAbsentDetails(row.absentDetail)

              setLeaveAbsent(true)
            }}
          >
            {row.absent}
            <span
              style={{
                color: "#000000",
                marginLeft: "2px",
                fontSize: "12px",
              }}
            >
              ({row.absentHour + "hrs"})
            </span>
          </span>
        )
      },
      headerStyle: {
        minWidth: "175px",
      },
    },

    {
      dataField: "delegationLeave",
      text: "Delegation",
      sort: true,
      formatter: (cellContent, row) => {
        return (
          <span
            style={{ color: "#E40D8C", cursor: "pointer", fontSize: "14px" }}
            onClick={() => {
              setDelegationDetails(row.delegationDetail)
              setDelegationCount(true)
            }}
          >
            {row.delegation}
            <span
              style={{
                color: "#000000",
                marginLeft: "2px",
                fontSize: "12px",
              }}
            >
              ({row.delegationHour + "hrs"})
            </span>
          </span>
        )
      },
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "nightShiftLeave",
      text: "Night Shift",
      sort: true,
      formatter: (cellContent, row) => {
        return (
          <span
            style={{ color: "#E40D8C", cursor: "pointer", fontSize: "14px" }}
            onClick={() => {
              setNightShiftDetails(row.nightShiftDetail)
              setNightShift(true)
            }}
          >
            {row.nightShift}
            <span
              style={{
                color: "#000000",
                marginLeft: "2px",
                fontSize: "12px",
              }}
            >
              ({row.nightShiftHour + "hrs"})
            </span>
          </span>
        )
      },
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "balanceCL",
      text: "Balance CL",
      sort: true,
      formatter: (cellContent, row) => {
        return <span style={{ fontSize: "14px" }}>{row.balanceCL}</span>
      },
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "balanceSL",
      text: "Balance SL",
      sort: true,
      formatter: (cellContent, row) => {
        return <span style={{ fontSize: "14px" }}>{row.balanceSL}</span>
      },
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "balancePermission",
      text: "Balance Permission",
      sort: true,
      formatter: (cellContent, row) => {
        return <span style={{ fontSize: "14px" }}>{row.balancePermission}</span>
      },
      headerStyle: {
        minWidth: "180px",
      },
    },
    {
      dataField: "workingDays",
      text: "Working Days",
      sort: true,
      csvExport: countFilterData ? true : false,
      headerStyle: {
        minWidth: "170px",
      },
      hidden: countFilterData ? false : true,
    },
  ]
  const today = moment().format("YYYY-MM-DD")
  var date = new Date()
  var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
  const startingDay = moment(firstDay).format("YYYY-MM-DD")
  console.log(startingDay, "startingDay")
  const statusList = [
    {
      label: "Inactive Employee",
      value: true,
    },
  ]
  console.log(employeeActive, "employeeActive")
  const handleStatusChange = async (e, value) => {
    let isChecked = e.target.checked
    console.log(e, "value")
    console.log("chooseData handle isChecked ", isChecked)
    if (isChecked) {
      setEmployeeActive(value)
      // setAuditChecked(true)
    } else {
      setEmployeeActive(false)
    }
    console.log("choose value", value)
  }

  const resetFormDetails = () => {
    setDepartmentlist([])
    setEmployeeCode([])
    setCompanies([])
    setBranches([])
    setDesignation([])
    setCountFilterData(false)
    setEmployeeActive(false)
    setEmployeeRecordData({
      fromDate: startingDay,
      toDate: today,
    })
    setSearchInput("")
    specificDispatch(
      employeeRecordAction.loadEmployeeRecord({
        employeeInactive: false,
        page: 1,
        limit: 50,
      })
    )

  }


  useEffect(() => {
    setTimeout(() => {
      if (applyFilter === false) {
        setEmployeeRecordData({
          ...employeeRecordData,
          fromDate: startingDay,
          toDate: today,
        })
      }
    }, 2000)
  }, [applyFilter])
  //Search filter

  const handleClick = (e) => {
    e.preventDefault()
    setSearchFilter(true)
    dispatch(
      employeeRecordAction.loadEmployeeRecord({
        searchFilter: searchInput,
        page: pageChange ? pageCount : 1,
        limit: 50,
        employeeInactive: employeeActive === true ? true : false
        // crmId:empId,
      }))

    setTimeout(() => {
      setSearchFilter(false)
    }, 1200)
  }
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }

  const exportToCsv = () => {

    var searchCompany = company && company ? company : ""
    var searchBranch = branch && branch ? branch : ""
    var searchDepartment =
      departmentlist && departmentlist.value ? [departmentlist.value] : ""
    var searchDesignation =
      designation && designation.value ? [designation.value] : ""
    var searchCount = employeeRecordData.count
    var searchEmpCode =
      employeeCode && employeeCode.value ? employeeCode.value : ""
    var searchEmpId =
      employeeCode && employeeCode.value ? employeeCode.value : ""
    var searchFromDate =
      employeeRecordData && employeeRecordData.fromDate
        ? employeeRecordData.fromDate
        : ""
    var searchToDate =
      employeeRecordData && employeeRecordData.toDate
        ? employeeRecordData.toDate
        : ""
    var searchEmpActive =
      employeeActive && employeeActive == true ? true : false
    var searchFilterType = countFilterData ? "count" : ""
    var searchvalue = {}

    if (searchCompany) {
      searchvalue.company = searchCompany
    }
    if (searchBranch) {
      searchvalue.branch = searchBranch
    }
    if (searchDepartment) {
      searchvalue.department = searchDepartment
    }
    if (searchDesignation) {
      searchvalue.designation = searchDesignation
    }
    if (searchEmpCode) {
      searchvalue.empId = searchEmpCode
    }
    if (searchFromDate) {
      searchvalue.startDate = searchFromDate
    }
    if (searchEmpActive) {
      searchvalue.employeeInactive = searchEmpActive
    }
    if (searchToDate) {
      searchvalue.endDate = searchToDate
    }
    if (searchEmpId) {
      searchvalue.empId = searchEmpId
    }
    if (searchCount) {
      searchvalue.count = searchCount
    }
    if (searchFilterType) {
      searchvalue.filterType = searchFilterType
    }
    setPageLoad(!pageLoad)
    setDownloadLoading(true)
    api
      .post(`/getEmployeeCurrentRecord`, searchvalue)
      .then((response) => {
        console.log(response)
        const photoExportDataTable = !isEmpty(response.data.Data)
          ? response.data.Data.map((employeeRecord, index) => {

            return {
              _id: employeeRecord._id,
              sNo: index + 1,
              branchId: employeeRecord.branchId,
              branchName: employeeRecord.branchName,
              companyId: employeeRecord.companyId,
              companyName: employeeRecord.companyName,
              departmentId: employeeRecord.departmentId,
              departmentName: employeeRecord.departmentName,
              designationId: employeeRecord.designationId,
              designationName: employeeRecord.designationName,
              employeeCode: employeeRecord.employeeCode,
              employeeName: employeeRecord.employeeName,
              workingDays: employeeRecord.workingDays,


              clDetail: employeeRecord.clDetail,
              leaveCL:
                employeeRecord.cl + `${"("} ${employeeRecord.clHour} ${"hrs)"}`,

              slDetail: employeeRecord.slDetail,
              leaveSL:
                employeeRecord.sl + `${"("} ${employeeRecord.slHour} ${"hrs)"}`,

              glDetail: employeeRecord.glDetail,
              leaveGL:
                employeeRecord.gl + `${"("} ${employeeRecord.glHour} ${"hrs)"}`,
              permission: employeeRecord.permission,
              permissionHour: employeeRecord.permissionHour,
              permissionDetail: employeeRecord.permissionDetail,
              permissionCount:
                employeeRecord.permission +
                `${"("} ${employeeRecord.permissionHour} ${"hrs)"}`,
              absent: employeeRecord.absent,
              absentHour: employeeRecord.absentHour,
              absentDetail: employeeRecord.absentDetail,
              leaveAbsent:
                employeeRecord.absent +
                `${"("} ${employeeRecord.absentHour} ${"hrs)"}`,

              leaveLate: (
                <span
                  style={{ color: "#E40D8C", cursor: "pointer", fontSize: "14px" }}

                >
                  {employeeRecord.late}
                </span>
              ),
              delegation: employeeRecord.delegation,
              delegationHour: employeeRecord.delegationHour,
              delegationDetail: employeeRecord.delegationDetail,
              delegationLeave:
                employeeRecord.delegation +
                `${"("} ${employeeRecord.delegationHour} ${"hrs)"}`,
              nightShift: employeeRecord.nightShift,
              nightShiftHour: employeeRecord.nightShiftHour,
              nightShiftDetail: employeeRecord.nightShiftDetail,
              nightShiftLeave:
                employeeRecord.nightShift +
                `${"("} ${employeeRecord.nightShiftHour} ${"hrs)"}`,

              balanceCL: employeeRecord.balanceCl,
              balanceSL: employeeRecord.balanceSl,
              balancePermission: employeeRecord.balancePermission,
              duration: employeeRecord.duration,

              key: index,
            }
          })
          : []
        setTimeout(() => {
          let headerDataOne = [
            "SNo,Emp Code,EMployee Name,Company,Branch,Department,Designation,CL,SL,GL,Permission Count,Employee Default,Delagation,Night Shift,Balance CL,Balance SL,Balance Permission"
          ]
          let headerDataTwo = [
            "SNo,Emp Code,EMployee Name,Company,Branch,Department,Designation,CL,SL,GL,Permission Count,Employee Default,Delagation,Night Shift,Balance CL,Balance SL,Balance Permission,Working Days"
          ]

          let usersCsv =
            photoExportDataTable.reduce((acc, user) => {
              if (countFilterData) {
                const {
                  sNo,
                  employeeCode,
                  employeeName,
                  companyName,
                  branchName,
                  departmentName,
                  designationName,
                  leaveCL,
                  leaveSL,
                  leaveGL,
                  permissionCount,
                  leaveAbsent,
                  delegationLeave,
                  nightShiftLeave,
                  balanceCL,
                  balanceSL,
                  balancePermission,
                  workingDays
                } = user
                acc.push([
                  sNo,
                  employeeCode,
                  employeeName,
                  companyName,
                  branchName,
                  departmentName,
                  designationName,
                  leaveCL,
                  leaveSL,
                  leaveGL,
                  permissionCount,
                  leaveAbsent,
                  delegationLeave,
                  nightShiftLeave,
                  balanceCL,
                  balanceSL,
                  balancePermission,
                  workingDays
                ])
              } else {
                const {
                  sNo,
                  employeeCode,
                  employeeName,
                  companyName,
                  branchName,
                  departmentName,
                  designationName,
                  leaveCL,
                  leaveSL,
                  leaveGL,
                  permissionCount,
                  leaveAbsent,
                  delegationLeave,
                  nightShiftLeave,
                  balanceCL,
                  balanceSL,
                  balancePermission
                } = user
                acc.push([
                  sNo,
                  employeeCode,
                  employeeName,
                  companyName,
                  branchName,
                  departmentName,
                  designationName,
                  leaveCL,
                  leaveSL,
                  leaveGL,
                  permissionCount,
                  leaveAbsent,
                  delegationLeave,
                  nightShiftLeave,
                  balanceCL,
                  balanceSL,
                  balancePermission
                ])
              }

              return acc
            }, [])
          const headerData = countFilterData ? headerDataTwo : headerDataOne
          downloadFile({
            data: [...headerData, ...usersCsv].join("\n"),
            fileName: "EmployeeRecord.csv",
            fileType: "text/csv",
          })
          setDownloadLoading(false)
        }, 2000)
        return response.data
      })
      .catch((error) => Promise.reject(error))
    // }
  }


  const RemotePagination = ({
    data,
    page,
    // sort,
    sizePerPage,
    onTableChange,
    totalSize,
  }) => (
    <div>
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          page,
          // sort,
          sizePerPage,
          totalSize,
        })}
      >
        {({ paginationProps, paginationTableProps }) => (
          <div>
            <ToolkitProvider
              keyField="_id"
              data={data}
              columns={columns}
              search
              exportCSV
            >
              {() => (
                <div>
                  <Col md="12" xl="12" lg="12" sm="12" xs="12">
                    <Row className="d-flex flex-row">
                      <Col className="mb-3" md="4">
                      </Col>

                      <Col md="8"
                        style={{ marginBottom: "20px", marginTop: "-41px" }}>

                        <Button
                          className="btn btn-primary"
                          onClick={exportToCsv}
                          id="download"
                          style={{
                            backgroundColor: "#e40d8c",
                            color: "white",
                            border: "none",
                            float: "right",
                            marginRight: "10px",
                          }}
                        >
                          Download
                        </Button>

                      </Col>

                      <Col>
                        <BootstrapTable
                          remote
                          keyField="_id"
                          data={data}
                          id="ImportTable"
                          columns={columns}
                          responsive
                          striped={true}
                          wrapperClasses="table-responsive"
                          bordered={true}
                          onTableChange={onTableChange}
                          {...paginationTableProps}
                        />
                      </Col>
                    </Row>
                    <Row
                      style={{ marginTop: "5px" }}
                      className="align-items-md-center mt-30"
                    >
                      <Col className="inner-custom-pagination d-flex">
                        <div className="d-inline d-flex flex-row">
                          <SizePerPageDropdownStandalone {...paginationProps} />
                          <div
                            style={{
                              fontSize: "14px",
                              marginTop: "8px",
                              marginLeft: "4px",
                            }}
                          >
                            <PaginationTotalStandalone {...paginationProps} />
                          </div>
                        </div>
                        <div
                          className="text-md-right ms-auto"
                          style={{ zIndex: 0 }}
                        >
                          <PaginationListStandalone
                            // paginationTotalRenderer={leave_list.totalDataCount}
                            {...paginationProps}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div>
              )}
            </ToolkitProvider>
          </div>
        )}
      </PaginationProvider>
    </div>
  )
  const [pageLoad, setPageLoad] = useState(false)
  const [state, setState] = useState({
    sizePerPage: 50,
    page: 1,
    totalSize: employee_record.length,
    data:
      !isEmpty(employee_record) && employee_record.length > 0
        ? employee_record.slice(0, 50)
        : [],
  })
  const { sizePerPage, page } = state

  //Table Change

  const handleTableChange = (type, { page, currentIndex, sizePerPage }) => {
    setPageCount(page)
    setPageChange(true)
    setPageLoad(!pageLoad)
    let result =
      !isEmpty(employee_record.data) && employee_record.data.length > 0
        ? employee_record.data
        : []
    if (
      !isEmpty(branch) ||
      !isEmpty(company) ||
      !isEmpty(departmentlist) ||
      !isEmpty(designation) ||
      !isEmpty(employeeCode) ||
      !isEmpty(employeeRecordData.fromDate) ||
      !isEmpty(employeeRecordData.toDate) ||
      !isEmpty(employeeActive)
    ) {

      var searchCompany = company && company ? company : ""
      var searchBranch = branch && branch ? branch : ""
      var searchDepartment =
        departmentlist && departmentlist.value ? [departmentlist.value] : ""
      var searchDesignation =
        designation && designation.value ? [designation.value] : ""
      // var searchLeaveType =
      //   leaveTypeList && leaveTypeList.label ? [leaveTypeList.label] : ""
      var searchEmpCode =
        employeeCode && employeeCode.value ? employeeCode.value : ""

      var searchFromDate =
        employeeRecordData && employeeRecordData.fromDate
          ? employeeRecordData.fromDate
          : ""
      var searchToDate =
        employeeRecordData && employeeRecordData.toDate
          ? employeeRecordData.toDate
          : ""
      var searchEmpActive =
        employeeActive && employeeActive == true ? true : false
      var searchvalue = {}
      searchvalue.page = page
      searchvalue.limit = sizePerPage ? sizePerPage : 50
      if (searchCompany) {
        searchvalue.company = searchCompany
      }
      if (searchBranch) {
        searchvalue.branch = searchBranch
      }
      if (searchDepartment) {
        searchvalue.department = searchDepartment
      }
      if (searchDesignation) {
        searchvalue.designation = searchDesignation
      }
      if (searchEmpCode) {
        searchvalue.empId = searchEmpCode
      }
      if (searchFromDate) {
        searchvalue.startDate = searchFromDate
      }
      if (searchEmpActive) {
        searchvalue.employeeInactive = searchEmpActive
      }
      if (searchToDate) {
        searchvalue.endDate = searchToDate
      }
      setPageLoad(!pageLoad)
      setLoading(true)
      specificDispatch(employeeRecordAction.loadEmployeeRecord(searchvalue))
    } else {
      dispatch(
        employeeRecordAction.loadEmployeeRecord({
          page: page,
          limit: sizePerPage,
          employeeInactive: false,
          // crmId:empId,
        })
      )
      setLoading(true)
      setPageLoad(!pageLoad)

    }
    // setPageCount(page)
    setTimeout(() => {
      setLoading(false)
    }, 2000)


    setState(() => ({
      page,
      data: result.slice(currentIndex, currentIndex + sizePerPage),
      totalSize: result.length,
      sizePerPage,
    }))
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={"Master"} breadcrumbItem={title} />
          {/* <Row>
            <Col lg="12" md="12" sm="12" xs="12" className="mb-4">
              <div className="filter-buttons" style={{ float: "right" }}>
                <Button
                  style={{
                    backgroundColor: "#E40D8C",
                    color: "#ffffff",
                    border: "none",
                    marginTop: "-20px",
                  }}
                  onClick={() => {
                    setApplyLeaveModal(true)
                    applyButton()
                    // setapplyLeaveradio(false)
                    // setapplyPermissionradio(false)
                  }}
                >
                  Apply Leave Absent
                </Button>
              </div>
            </Col>
          </Row> */}

          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <form>
                    <Row>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Company"}>
                            {" "}
                            {"Company"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="company"
                          isMulti
                          value={companies}
                          style={{ zIndex: 10000 }}
                          onChange={(e) => handleCompaniesChange(e)}
                          options={
                            recordsMetaData
                              ? recordsMetaData.companyOptions
                              : []
                          }
                          placeholder="Select Company"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Branch"}>
                            {"Branch"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="branch"
                          isMulti
                          value={branches}
                          onChange={(e) => setBranches(e)}
                          options={branchOptions}
                          placeholder="Select Branch"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className={"form-label"}
                            htmlFor={"Department"}
                          >
                            {"Department"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="Department"
                          value={departmentlist}
                          onChange={(e) => setDepartmentlist(e)}
                          options={
                            recordsMetaData
                              ? recordsMetaData.departmentOptions
                              : []
                          }
                          placeholder="Select Department"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className={"form-label"}
                            htmlFor={"Designation"}
                          >
                            {"Designation"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="designation"
                          value={designation}
                          onChange={(e) => setDesignation(e)}
                          options={
                            recordsMetaData
                              ? recordsMetaData.designationOptions
                              : []
                          }
                          placeholder="Select Designation"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className={"form-label"}
                            htmlFor={"Employee Code"}
                          >
                            {"Employee Code"}
                          </Label>
                        </div>
                        <ReactSearchAutocomplete
                          name="employeeCode"
                          items={employeeOptions}
                          value={employeeCode}
                          type="autoComplete"
                          resultStringKeyName="label"
                          showIcon={false}
                          onSelect={(e) => setEmployeeCode(e)}
                          onChange={(e) => setEmployeeCode(e.target.value)}
                          placeholder="Enter Employee Code"
                          fuseOptions={fuseOptions} // Search on both fields
                          styling={{
                            height: "34px",
                            border: "1px solid #ced4da",
                            borderRadius: "4px",
                            backgroundColor: "white",
                            boxShadow: "none",
                            hoverBackgroundColor: "#E40D8C",
                            color: "black",
                            fontSize: "12px",
                            fontFamily: "Courier",
                            iconColor: "green",
                            clearIconMargin: "3px 8px 0 0",
                            zIndex: 0,
                          }}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"From Date"}>
                            {"From Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="YYYY-MM-DD"
                          name="fromDate"
                          max={employeeRecordData.toDate}
                          value={employeeRecordData.fromDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"From Date"}>
                            {"To Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="YYYY-MM-DD"
                          name="toDate"
                          min={employeeRecordData.fromDate}
                          value={employeeRecordData.toDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <Row className="d-flex flex-row">
                          <Col lg="9" md="9" sm="9" xs="9">
                            <div className="d-flex justify-content-between">
                              <Label
                                className="form-label"
                                htmlFor={"From Date"}
                              >
                                {"Count"}
                              </Label>
                            </div>
                            <Input
                              type="text"
                              placeholder="Enter The Count"
                              name="count"
                              value={
                                employeeRecordData.count <= counterDate
                                  ? employeeRecordData.count
                                  : ""
                              }
                              onChange={(e) => handleChange(e)}
                            />
                            {simpleValidator.current.message(
                              "count",
                              employeeRecordData.count,
                              "required"
                            )}
                          </Col>
                          <Col
                            lg="3"
                            md="3"
                            sm="3"
                            xs="3"
                            className="mt-4 apply-record-btn"
                          >
                            <Button
                              type="submit"
                              onClick={(e) => {
                                countFilter(e)
                              }}
                              className="btn btn-success"
                            >
                              <i className="bx bx-search-alt search-icon mt-1" />
                            </Button>
                          </Col>
                        </Row>
                      </Col>
                      <Col lg="3" md="3" sm="3" xs="3" className="mt-4">
                        <div className="d-flex flex-row">
                          {statusList.map((status, index) => {
                            return (
                              <div className="d-flex flex-row" key={index}>
                                <Input
                                  type="checkbox"
                                  name="employeeActive"
                                  value={status.value}
                                  // defaultChecked={
                                  //   employeeActive != status.value
                                  //     ? false
                                  //     : true
                                  // }
                                  checked={employeeActive === status.value}
                                  // className={status.value ? "audit-status-border" : ""}
                                  onChange={(e) =>
                                    handleStatusChange(e, status.value)
                                  }
                                  className="font-size-15"
                                />
                                <Label
                                  className="mx-2"
                                  style={{ marginTop: "2px", fontSize: "12px" }}
                                >
                                  {status.label}
                                </Label>
                              </div>
                            )
                          })}
                          {/* <Input
                            type="checkbox"
                            name="employeeActive"
                            onChange={(e) => {
                              setEmployeeActive(e.target.checked)
                            }}
                            value={employeeActive}
                            id="checkbox"
                            className="font-size-15"
                          />
                          <Label className="mx-2 mt-1">Inactive Employee</Label> */}
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="12" md="12" sm="12" xs="12" className="mt-5">
                        <div
                          className="filter-buttons"
                          style={{ float: "right" }}
                        >
                          <Button
                            type="button"
                            className="btn btn-danger btn-label simple-form-Reset-btn mx-2"
                            onClick={() => resetFormDetails()}
                          >
                            <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                            Reset
                          </Button>
                          <Button
                            type="button"
                            onClick={() => handleApply()}
                            className="btn btn-success btn-label simple-form-applyfilter-btn"
                          >
                            <i className="bx bx-filter-alt label-icon"></i>
                            {btnLoader && btnLoader ? (
                              <ButtonSpinner />
                            ) : (
                              "Apply Filter"
                            )}{" "}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {/*Table start*/}
          <Row>
            <Col md="12" lg="12" xl="12">
              <Card>
                <CardBody>
                  <div
                    className="d-flex flex-row"
                    style={{ marginTop: "20px" }}
                  >
                    <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                      <form onSubmit={handleClick} className="d-flex flex-row">
                        <div style={searchBtnStyle || null}>
                          <Input
                            type="text"
                            name="searchInput"
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                            className="form-control"
                            placeholder="Search"
                            style={{ position: "relative" }}
                          />
                          <i
                            className="bx bx-search-alt"
                            style={{
                              position: "absolute",
                              top: "54px",
                              left: "41px",
                              fontSize: "13px",
                            }}
                          />
                        </div>
                        <button
                          className="btn btn-success mx-2"
                          type="submit"
                          style={{
                            background: searchFilter ? "#2ca67a" : "",
                            color: searchFilter ? "#ffffff" : "",
                          }}
                        >
                          <i className="fas fa-search"></i>
                        </button>
                      </form>
                    </div>
                  </div>{" "}
                  <RemotePagination
                    data={employeeRecordTable}
                    page={page}
                    sizePerPage={sizePerPage}
                    totalSize={!isEmpty(employee_record) ? employee_record.totalDataCount : 0}
                    onTableChange={handleTableChange}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        {leaveCL && (
          <Modal show={leaveCL} onHide={handleLeaveCL} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Leave CL</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  {/* <div>No Records Found</div> */}
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "20px" }}>Request No</th>
                          <th style={{ width: "70px" }}>From Date</th>
                          <th style={{ width: "70px" }}>To Date</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {leaveCLDetails && leaveCLDetails.length > 0 ? (
                          leaveCLDetails.map((cl, index) => {
                            const attachment = isEmpty(cl.attachments)
                              ? ""
                              : cl.attachments.substring(
                                cl.attachments.lastIndexOf(".") + 1
                              )

                            // console.log(attachment, "attachment")
                            var fromDate = moment(cl.fromDate).format(
                              "DD-MM-YYYY"
                            )
                            var toDate = !isEmpty(cl.toDate)
                              ? moment(cl.toDate)
                                .subtract(5, "hours")
                                .subtract(30, "minutes")
                                .format("DD-MM-YYYY")
                              : []

                            return (
                              <>
                                <tr key={cl._id}>
                                  <td>{index + 1}</td>
                                  <td>{cl.requestNo}</td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{cl.leaveDuration}</td>
                                  <td>{cl.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                      attachment === "jpg" ||
                                      attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(cl.attachments, "_blank")
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={cl.attachments}>
                                        <audio controls>
                                          <source
                                            src={cl.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(cl.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{cl.leaveStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleLeaveCL}
              >
                Cancel
              </Button>
              {/* <Button
                       variant="primary"
                       className="btn btn-success"
                       onClick={() => {
                         handleLeaveCL()
                       }}
                     >
                       Submit
                     </Button> */}
            </Modal.Footer>
          </Modal>
        )}
        {leaveSL && (
          <Modal show={leaveSL} onHide={handleLeaveSL} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Leave SL</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  {/* <div>No Records Found</div> */}
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "20px" }}>Request No</th>
                          <th style={{ width: "70px" }}>From Date</th>
                          <th style={{ width: "70px" }}>To Date</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {leaveSLDetails && leaveSLDetails.length > 0 ? (
                          leaveSLDetails.map((sl, index) => {
                            const attachment = isEmpty(sl.attachments)
                              ? ""
                              : sl.attachments.substring(
                                sl.attachments.lastIndexOf(".") + 1
                              )

                            // console.log(attachment, "attachment")
                            var fromDate = moment(sl.fromDate).format(
                              "DD-MM-YYYY"
                            )
                            var toDate = !isEmpty(sl.toDate)
                              ? moment(sl.toDate)
                                .subtract(5, "hours")
                                .subtract(30, "minutes")
                                .format("DD-MM-YYYY")
                              : []
                            return (
                              <>
                                <tr key={sl._id}>
                                  <td>{index + 1}</td>
                                  <td>{sl.requestNo}</td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{sl.leaveDuration}</td>
                                  <td>{sl.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                      attachment === "jpg" ||
                                      attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(sl.attachments, "_blank")
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={sl.attachments}>
                                        <audio controls>
                                          <source
                                            src={sl.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(sl.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{sl.leaveStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleLeaveSL}
              >
                Cancel
              </Button>
              {/* <Button
                       variant="primary"
                       className="btn btn-success"
                       onClick={() => {
                         handleLeaveSL()
                       }}
                     >
                       Submit
                     </Button> */}
            </Modal.Footer>
          </Modal>
        )}
        {leaveGL && (
          <Modal show={leaveGL} onHide={handleLeaveGL} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Leave GL</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  {/* <div>No Records Found</div> */}
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "20px" }}>Request No</th>
                          <th style={{ width: "70px" }}>From Date</th>
                          <th style={{ width: "70px" }}>To Date</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {leaveGLDetails && leaveGLDetails.length > 0 ? (
                          leaveGLDetails.map((gl, index) => {
                            const attachment = isEmpty(gl.attachments)
                              ? "--"
                              : gl.attachments.substring(
                                gl.attachments.lastIndexOf(".") + 1
                              )

                            // console.log(attachment, "attachment")
                            var fromDate = moment(gl.fromDate).format(
                              "DD-MM-YYYY"
                            )
                            var toDate = !isEmpty(gl.toDate)
                              ? moment(gl.toDate)
                                .subtract(5, "hours")
                                .subtract(30, "minutes")
                                .format("DD-MM-YYYY")
                              : []
                            return (
                              <>
                                <tr key={gl._id}>
                                  <td>{index + 1}</td>
                                  <td>{gl.requestNo}</td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{gl.leaveDuration}</td>
                                  <td>{gl.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                      attachment === "jpg" ||
                                      attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(gl.attachments, "_blank")
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={gl.attachments}>
                                        <audio controls>
                                          <source
                                            src={gl.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(gl.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{gl.leaveStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleLeaveGL}
              >
                Cancel
              </Button>
              {/* <Button
                       variant="primary"
                       className="btn btn-success"
                       onClick={() => {
                         handleLeaveGL()
                       }}
                     >
                       Submit
                     </Button> */}
            </Modal.Footer>
          </Modal>
        )}
        {permissionCount && (
          <Modal
            show={permissionCount}
            onHide={handlePermissionCount}
            size="lg"
          >
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Permission Count</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  {/* <div>No Records Found</div> */}
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {permissionDetails && permissionDetails.length > 0 ? (
                          permissionDetails.map((permission, index) => {
                            const attachment = isEmpty(permission.attachments)
                              ? ""
                              : permission.attachments.substring(
                                permission.attachments.lastIndexOf(".") + 1
                              )

                            // console.log(attachment, "attachment")
                            var date = moment(permission.date).format(
                              "DD-MM-YYYY"
                            )
                            return (
                              <>
                                <tr key={permission._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{permission.fromTime}</td>
                                  <td>{permission.toTime}</td>
                                  <td>{permission.duration}</td>
                                  <td>{permission.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                      attachment === "jpg" ||
                                      attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            permission.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={permission.attachments}>
                                        <audio controls>
                                          <source
                                            src={permission.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(permission.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{permission.permissionStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handlePermissionCount}
              >
                Cancel
              </Button>
              {/* <Button
                       variant="primary"
                       className="btn btn-success"
                       onClick={() => {
                         handlePermissionCount()
                       }}
                     >
                       Submit
                     </Button> */}
            </Modal.Footer>
          </Modal>
        )}
        {leaveAbsent && (
          <Modal show={leaveAbsent} onHide={handleLeaveAbsent} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Leave Absent</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  {/* <div>No Records Found</div> */}
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "50px" }}>Date</th>
                          <th style={{ width: "50px" }}>Absent Type</th>
                          <th style={{ width: "50px" }}>Request Type</th>
                          <th style={{ width: "50px" }}>Reason</th>
                          <th style={{ width: "50px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>From Date</th>
                          <th style={{ width: "50px" }}>To Date</th>
                          <th style={{ width: "50px" }}>Start Time</th>
                          <th style={{ width: "50px" }}>End Time</th>
                          <th style={{ width: "50px" }}>Duration</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {leaveAbsentDetails && leaveAbsentDetails.length > 0 ? (
                          leaveAbsentDetails.map((absent, index) => {
                            const attachment = isEmpty(absent.attachments)
                              ? ""
                              : absent.attachments.substring(
                                absent.attachments.lastIndexOf(".") + 1
                              )

                            // console.log(attachment, "attachment")
                            var date = moment(absent.date).format("DD-MM-YYYY")
                            var fromDate = isEmpty(absent.fromDate)
                              ? "--"
                              : moment(absent.fromDate).format("DD-MM-YYYY")

                            var toDate = isEmpty(absent.toDate)
                              ? "--"
                              : moment(absent.toDate)
                                .subtract(5, "hours")
                                .subtract(30, "minutes")
                                .format("DD-MM-YYYY")

                            return (
                              <>
                                <tr key={absent._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{absent.absentType}</td>
                                  <td>{absent.requestTypeId}</td>
                                  <td>{absent.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                      attachment === "jpg" ||
                                      attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            absent.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={absent.attachments}>
                                        <audio controls>
                                          <source
                                            src={absent.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(absent.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{absent.fromTime}</td>
                                  <td>{absent.toTime}</td>
                                  <td>{absent.duration}</td>
                                  <td>{absent.absentStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={14}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleLeaveAbsent}
              >
                Cancel
              </Button>
              {/* <Button
                       variant="primary"
                       className="btn btn-success"
                       onClick={() => {
                         handleLeaveAbsent()
                       }}
                     >
                       Submit
                     </Button> */}
            </Modal.Footer>
          </Modal>
        )}
        {/* {leaveLate && (
          <Modal show={leaveLate} onHide={handleLeaveLate} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Leave Late</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "50px" }}>Date</th>
                          <th style={{ width: "50px" }}>Absent Type</th>
                          <th style={{ width: "50px" }}>Request Type</th>
                          <th style={{ width: "50px" }}>Reason</th>
                          <th style={{ width: "50px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {leaveLateDetails && leaveLateDetails.length > 0 ? (
                          leaveLateDetails.map((late, index) => {
                            const attachment = isEmpty(late.attachments)
                              ? "--"
                              : late.attachments.substring(
                                  late.attachments.lastIndexOf(".") + 1
                                )

                            console.log(attachment, "attachment")
                            var date = moment(late.date).format("YYYY-MM-DD")
                            return (
                              <>
                                <tr key={late._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{late.fromTime}</td>
                                  <td>{late.toTime}</td>
                                  <td>{late.duration}</td>
                                  <td>{late.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            late.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={late.attachments}>
                                        <audio controls>
                                          <source
                                            src={late.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(late.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{late.lateStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={9}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleLeaveLate}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )} */}
        {delegationCount && (
          <Modal
            show={delegationCount}
            onHide={handleDelegationAbsent}
            size="lg"
          >
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Delegation Count</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  {/* <div>No Records Found</div> */}
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {delegationDetails && delegationDetails.length > 0 ? (
                          delegationDetails.map((delegation, index) => {
                            const attachment = isEmpty(delegation.attachments)
                              ? "--"
                              : delegation.attachments.substring(
                                delegation.attachments.lastIndexOf(".") + 1
                              )

                            // console.log(attachment, "attachment")
                            var date = moment(delegation.date).format(
                              "YYYY-MM-DD"
                            )
                            return (
                              <>
                                <tr key={delegation._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{delegation.fromTime}</td>
                                  <td>{delegation.toTime}</td>
                                  <td>{delegation.duration}</td>
                                  <td>{delegation.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                      attachment === "jpg" ||
                                      attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            delegation.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={delegation.attachments}>
                                        <audio controls>
                                          <source
                                            src={delegation.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(delegation.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{delegation.delegationStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleDelegationAbsent}
              >
                Cancel
              </Button>
              {/* <Button
                       variant="primary"
                       className="btn btn-success"
                       onClick={() => {
                         handleDelegationAbsent()
                       }}
                     >
                       Submit
                     </Button> */}
            </Modal.Footer>
          </Modal>
        )}
        {nightShift && (
          <Modal show={nightShift} onHide={handleNightShift} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Night Shift</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  {/* <div>No Records Found</div> */}
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {nightShiftDetails && nightShiftDetails.length > 0 ? (
                          nightShiftDetails.map((shift, index) => {
                            const attachment = isEmpty(shift.attachments)
                              ? "--"
                              : shift.attachments.substring(
                                shift.attachments.lastIndexOf(".") + 1
                              )

                            // console.log(attachment, "attachment")
                            var date = moment(shift.date).format("YYYY-MM-DD")
                            return (
                              <>
                                <tr key={shift._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{shift.fromTime}</td>
                                  <td>{shift.toTime}</td>
                                  <td>{shift.duration}</td>
                                  <td>{shift.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                      attachment === "jpg" ||
                                      attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            shift.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={shift.attachments}>
                                        <audio controls>
                                          <source
                                            src={shift.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(shift.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{shift.nightShiftStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleNightShift}
              >
                Cancel
              </Button>
              {/* <Button
                       variant="primary"
                       className="btn btn-success"
                       onClick={() => {
                         handleNightShift()
                       }}
                     >
                       Submit
                     </Button> */}
            </Modal.Footer>
          </Modal>
        )}
        {loading ? (
          <Modal show={loading} style={{ width: "7%", margin: "18% 50%" }}>
            <Modal.Body>
              <Spinner
                as="span"
                animation="grow"
                size="lg"
                role="status"
                aria-hidden="true"
                variant="success"
                className="mx-2"
                color="success"
              />
              {/* <span>Loading...</span> */}
            </Modal.Body>
          </Modal>
        ) : (
          ""
        )}
        {downloadLoading ? (
          <Modal
            show={downloadLoading}
            style={{ width: "7%", margin: "18% 50%" }}
          >
            <Modal.Body>
              <Spinner
                as="span"
                animation="grow"
                size="lg"
                role="status"
                aria-hidden="true"
                variant="success"
                className="mx-2"
                color="success"
              />
              {/* <span>Loading...</span> */}
            </Modal.Body>
          </Modal>
        ) : (
          ""
        )}
      </div>
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </React.Fragment>
  )
}
EmployeeRecord.propTypes = {
  dispatch: PropTypes.func,
  recordsMetaData: PropTypes.array,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  csvProps: PropTypes.any,
  searchBtnStyle: PropTypes.any,
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  totalSize: PropTypes.number.isRequired,
  sizePerPage: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
  //isInvalid:PropTypes.any
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  // employee: state.employeeRequest.employee,
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EmployeeRecord)
)
